import React, { lazy } from 'react';
// import { JournalEntryRoutes } from '../ProjectCostingModule/ProjectCostingRoutes/JournalEntryRoutes';
const ProjectCashVoucherEntryDetail = lazy(() =>
  import('./ProjectCashVoucherEntryDetail').then(module => ({
    default: module.ProjectCashVoucherEntryDetail,
  })),
);

const ProjectCashVoucherEntryListing = lazy(() =>
  import('./ProjectCashVoucherEntryListing').then(module => ({
    default: module.ProjectCashVoucherEntryListing,
  })),
);

const ProjectCashVoucherEntryForm = lazy(() =>
  import('./ProjectCashVoucherEntryForm').then(module => ({
    default: module.ProjectCashVoucherEntryForm,
  })),
);

const ProjectCashVoucherEntryItemForm = lazy(() =>
  import('./components/ProjectCashVoucherEntryItemForm').then(module => ({
    default: module.ProjectCashVoucherEntryItemForm,
  })),
);

// const ProjectCostAdjustmentDetail = lazy(() =>
//   import('./ProjectCostAdjustmentDetail').then(module => ({
//     default: module.ProjectCostAdjustmentDetail,
//   })),
// );

// const CostingPreviewDetailPDF = lazy(() =>
//   import(
//     '../ProjectCostingModule/ProjectCostingPDF/CostingPreviewDetailPDF'
//   ).then(module => ({
//     default: module.CostingPreviewDetailPDF,
//   })),
// );

const projectCashVoucherEntryRoutes = [
  // ...JournalEntryRoutes,
  {
    props: {
      exact: true,
      path: '/cash-voucher-entry',
    },
    component: <ProjectCashVoucherEntryListing />,
  },
  {
    props: {
      exact: true,
      path: '/cash-voucher-entry/detail/:cashVoucherEntryID',
    },
    component: <ProjectCashVoucherEntryDetail />,
  },
  {
    props: {
      exact: true,
      path: '/cash-voucher-entry/new',
    },
    component: <ProjectCashVoucherEntryForm mode="new" />,
  },
  {
    props: {
      exact: true,
      path: '/cash-voucher-entry/approve-reject/:cashVoucherEntryID',
    },
    component: <ProjectCashVoucherEntryForm mode="approve-reject" />,
  },
  {
    props: {
      exact: true,
      path: '/cash-voucher-entry/approve-reject/workdesk/:cashVoucherEntryID',
    },
    component: <ProjectCashVoucherEntryForm mode="approve-reject" />,
  },
  {
    props: {
      exact: true,
      path: '/cash-voucher-entry/:formMode/:cashVoucherEntryID',
    },
    component: <ProjectCashVoucherEntryForm mode="edit" />,
  },
  {
    props: {
      exact: true,
      path: '/cash-voucher-entry/:formMode/item/add',
    },
    component: <ProjectCashVoucherEntryItemForm mode="new" />,
  },
  {
    props: {
      exact: true,
      path: '/cash-voucher-entry/:formMode/item/:itemMode/:itemID',
    },
    component: <ProjectCashVoucherEntryItemForm mode="new" />,
  },
  {
    props: {
      exact: true,
      path: '/cash-voucher-entry/:formMode/:cashVoucherEntryID/item/add',
    },
    component: <ProjectCashVoucherEntryItemForm mode="new" />,
  },
  {
    props: {
      exact: true,
      path:
        '/cash-voucher-entry/:formMode/:cashVoucherEntryID/item/:itemMode/:itemID',
    },
    component: <ProjectCashVoucherEntryItemForm mode="new" />,
  },
  //   {
  //     props: {
  //       exact: true,
  //       path:
  //         '/cash-voucher-entry/detail/:costAdjustmentID/journal-entry/e-letter',
  //     },
  //     component: (
  //       <CostingPreviewDetailPDF
  //         docType="journal-entry"
  //         accountType="project-costing"
  //         entityIdParam="costAdjustmentID"
  //       />
  //     ),
  //   },
];

export default projectCashVoucherEntryRoutes;
